import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { BtrBookingService } from '../../core/services/btr-booking.service';
import { IAppConfig } from '../../core/config/app-config.model';
import { APP_CONFIG } from '../../core/config/app-config.service';
import { RatePlan } from '../../core/api/api.models';

export interface Discount {
  accessCode: string
  approvalCode: string
  bookingFromDate: string
  bookingToDate: string
  code: string
  description: string
  id: number
  isLongStayUse: boolean
  isShortStayUse: boolean
  isStaffUseOnly: boolean
  name: string
  recordStatus: boolean
  stayFromDate: string
  stayToDate: string,
  expired: boolean
}

export interface Criteria {
  property: string,
  stayFromDate: Date,
  stayToDate: Date,
}

@Component({
  selector: 'app-booking-discount-form',
  standalone: false,
  templateUrl: './booking-discount-form.component.html',
  styleUrls: ['./booking-discount-form.component.sass']
})
export class BookingDiscountFormComponent implements OnInit {

  constructor(
    private btrBookingService: BtrBookingService,
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ) { }

  @Input('discounts') discounts: Discount[] = []

  discountForm: {
    discountCode: string,
    errors: {
      discountCode?: string
    },
    isProcessing?: boolean
  } = {
      discountCode: '',
      isProcessing: false,
      errors: {}
    }

  @Input('criteria') criteria?: Criteria
  @Output('onDiscountChanged') onDiscountChanged = new EventEmitter<Discount[]>();
  @Input('selectedRoomRate') selectedRoomRate?: RatePlan


  allowInputDiscount = true;

  verifyRatePlan = false;

  ngOnInit(): void {
  }

  applyDiscountCode() {
    if (this.discountForm.isProcessing) return;

    if (!this.discountForm.discountCode || !this.discountForm.discountCode.trim()) {
      this.discountForm.errors = {
        discountCode: 'error.discount-code-required'
      }
      return;
    }

    // check if this discount code is used
    const discountCode = this.discountForm.discountCode.trim();
    const exists = this.discounts.some(e => e.accessCode === discountCode);
    if (exists) {
      this.discountForm.errors = {
        discountCode: 'error.discount-code-used'
      };
      return;
    }

    this.discountForm.errors = {};
    this.discountForm.isProcessing = true;
    this.searchDiscountCode([discountCode]);
  }

  searchDiscountCode(discountCode: string[]) {
    this.btrBookingService.readSearchDiscountByAccessCodeDistributionChannelCode({
      accessCode: discountCode,
      propertyCode: this.criteria?.property || '',
      distributionChannelCode: this.config.apiServer.distributionChannelCode,
      stayFromDate: this.criteria?.stayFromDate || new Date(),
      stayToDate: this.criteria?.stayToDate || new Date(),
    }).subscribe(res => {
      this.discountForm.isProcessing = false;
      if(res.success && res.collection && res.collection.length){

        let hasAvailableDiscount = false;
        res.collection.forEach(e => {
          const exists = this.discounts.some(d => e.accessCode === d.accessCode);
          if(!exists){
            let valid = true;
            if(e.isStaffUseOnly){
              // this discount code for staff only, invalid code
              valid = false;
            }
            else if(this.verifyRatePlan && this.selectedRoomRate && e.isLongStayUse && this.selectedRoomRate.recordType === 'ShortStay'){
              // this discount code is using only for "LongStay"
              valid = false;
            }
            else if(this.verifyRatePlan && this.selectedRoomRate && e.isShortStayUse && this.selectedRoomRate.recordType === 'LongStay'){
              // this discount code is uing only for "ShortStay"
              valid = false;
            }
            else if(!e.items || !e.items.length){
              valid = false;
            }
            if(valid){
              this.discounts.push({...e, expired: false})
              hasAvailableDiscount = true;
            }
            else{
              this.discountForm.errors = {
                discountCode: 'error.discount-code-invalid'
              }
            }
          } else {

          }
        });

        discountCode.forEach(e => {
          if(!res.collection.some(dis => dis.accessCode === e)){
            const discount = this.discounts.find(dis => dis.accessCode === e)
            discount && (discount.expired = true) 
          }
        })

        this.onDiscountChanged.emit(this.discounts);

        if(hasAvailableDiscount){
          this.resetDiscountForm();
        }
      }
      else{
        this.discountForm.errors = {
          discountCode: 'error.discount-code-invalid'
        }
      }
    })
  }

  removeDiscount(discount: Discount) {
    const index = this.discounts.indexOf(discount);
    if (index !== -1) {
      this.discounts.splice(index, 1);
      this.onDiscountChanged.emit(this.discounts);
    }
  }

  resetDiscountForm() {
    this.discountForm = {
      discountCode: '',
      errors: {}
    }
  }
}
